import React from 'react';
import { Card, Text, Group, Stack, Progress, Box } from '@mantine/core';
import { Building2, Calendar, TrendingUp } from 'lucide-react';
import type { Property } from '../types';
interface PropertyCardProps {
  property: Property;
  onClick?: () => void;
}
export function PropertyCard({
  property,
  onClick
}: PropertyCardProps) {
  const formatCurrency = (amount: number) => {
    return new Intl.NumberFormat('en-AE', {
      style: 'currency',
      currency: 'AED',
      minimumFractionDigits: 0
    }).format(amount);
  };
  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleDateString('en-US', {
      month: 'short',
      day: 'numeric',
      year: 'numeric'
    });
  };
  return <Card shadow="sm" padding="lg" radius="md" withBorder onClick={onClick} style={{
    cursor: onClick ? 'pointer' : 'default'
  }} styles={{
    root: {
      borderColor: '#e2e8f0',
      transition: 'all 0.2s ease',
      '&:hover': onClick ? {
        borderColor: '#10b981',
        transform: 'translateY(-2px)',
        boxShadow: '0 4px 12px rgba(16, 185, 129, 0.15)'
      } : {}
    }
  }} data-id="element-91">
      <Stack gap="md" data-id="element-92">
        {/* Property Image */}
        <Box style={{
        borderRadius: 12,
        overflow: 'hidden',
        height: 140,
        background: `url(${property.image}) center/cover`
      }} data-id="element-93" />

        {/* Property Info */}
        <Stack gap="xs" data-id="element-94">
          <Text fw={700} size="lg" c="#1a2332" data-id="element-95">
            {property.name}
          </Text>
          <Group gap="xs" data-id="element-96">
            <Building2 size={14} color="#64748b" data-id="element-97" />
            <Text size="sm" c="#64748b" data-id="element-98">
              {property.projectName} • Unit {property.unitId}
            </Text>
          </Group>
        </Stack>

        {/* Next Installment */}
        {property.nextInstallment && <Box p="sm" style={{
        backgroundColor: '#f8fafc',
        borderRadius: 8,
        border: '1px solid #e2e8f0'
      }} data-id="element-99">
            <Group justify="space-between" align="center" data-id="element-100">
              <Stack gap={2} data-id="element-101">
                <Text size="xs" c="#64748b" tt="uppercase" fw={500} data-id="element-102">
                  Next Installment
                </Text>
                <Text fw={700} size="md" c="#1a2332" data-id="element-103">
                  {formatCurrency(property.nextInstallment.amount)}
                </Text>
              </Stack>
              <Group gap={4} data-id="element-104">
                <Calendar size={14} color="#64748b" data-id="element-105" />
                <Text size="sm" c="#64748b" data-id="element-106">
                  {formatDate(property.nextInstallment.dueDate)}
                </Text>
              </Group>
            </Group>
          </Box>}

        {/* Construction Progress */}
        <Stack gap="xs" data-id="element-107">
          <Group justify="space-between" data-id="element-108">
            <Group gap={4} data-id="element-109">
              <TrendingUp size={14} color="#10b981" data-id="element-110" />
              <Text size="sm" fw={500} c="#1a2332" data-id="element-111">
                Construction Progress
              </Text>
            </Group>
            <Text size="sm" fw={600} c="#10b981" data-id="element-112">
              {property.constructionProgress}%
            </Text>
          </Group>
          <Progress value={property.constructionProgress} size="sm" radius="xl" color="#10b981" styles={{
          root: {
            backgroundColor: '#e2e8f0'
          }
        }} data-id="element-113" />
        </Stack>
      </Stack>
    </Card>;
}